import React, { useState } from 'react';
import './SignIn.css';
import Appgate_Logo from '../../assets/images/Appgate_Logo.png'

interface SignInProps {
  onSubmit?: (useremail: string, password: string) => void;
}

const SignIn: React.FC<SignInProps> = ({ onSubmit }) => {
  const [useremail, setUseremail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(useremail, password);
    }
  };

  return (
    <div className="signin-container">
      <div style={{width:'100vw',backgroundColor:'#2B0050'}}></div>
      <div style={{color:'#2D2076',width:'100vw',zIndex:'1'}}></div>
      <div className="signin-card">
        <h1 className="signin-title">Signin</h1>
        
        <div className="signin-form">
          <div className="input-group">
            <label className="input-label">User Email</label>
            <input
              type="text"
              value={useremail}
              onChange={(e) => setUseremail(e.target.value)}
              className="input-field-signIn"
            />
          </div>
          
          <div className="input-group">
            <label className="input-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field-signIn"
            />
          </div>
          
          <button style={{marginTop:"23%"}} onClick={handleSubmit} className="submit-button">
            Enter
          </button>
        </div>
        
        <div className="signin-footer">
         <img src={Appgate_Logo} alt="Delete"  />
        </div>
      </div>
    </div>
  );
};

export default SignIn;

// import React, { useState } from 'react';
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Stack,
//   AppBar,
//   Toolbar
// } from '@mui/material';
// import Appgate_Logo from '../../assets/images/Appgate_Logo.png'
// import { styled } from '@mui/material/styles';

// interface SignInProps {
//   onSubmit?: (username: string, password: string) => void;
// }

// // Styled components
// const StyledContainer = styled(Container)({
//   minHeight: '100vh',
//   backgroundColor: '#f5f5f5',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   flexDirection: 'column',
//   fontFamily: 'Arial, sans-serif',
// });

// const StyledBox = styled(Box)({
//   backgroundColor: '#f5f5f5',
//   padding: '40px',
//   width: '100%',
//   maxWidth: '400px',
// });

// const StyledTitle = styled(Typography)({
//   fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
//   textAlign: 'center',
//   marginBottom: '50px',
//   fontSize: '70px',
//   fontWeight: 700,
//   color: '#2D2076',
// });

// const StyledTextField = styled(TextField)({
//   width: '100%',
//   '& .MuiOutlinedInput-root': {
//     backgroundColor: 'white',
//     fontSize: '20px',
//     borderRadius: '6px',
//     '& fieldset': {
//       borderColor: '#2D2076',
//     },
//     '&:hover fieldset': {
//       borderColor: '#2D2076',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: '#2D2076',
//       boxShadow: '0 0 0 2px rgba(45, 32, 118, 0.2)',
//     },
//   },
//   '& .MuiInputLabel-root': {
//     color: '#2D2076',
//     fontSize: '16px',
//     '&.Mui-focused': {
//       color: '#2D2076',
//     },
//   },
// });

// const StyledButton = styled(Button)({
//   width: '100%',
//   backgroundColor: '#2D2076',
//   color: 'white',
//   fontWeight: 600,
//   padding: '18px 10px',
//   borderRadius: '6px',
//   fontSize: '24px',
//   marginTop: '23%',
//   '&:hover': {
//     backgroundColor: '#2D2076',
//     transform: 'scale(1.02)',
//   },
//   '&:focus': {
//     boxShadow: '0 0 0 3px rgba(45, 32, 118, 0.3)',
//   },
// });

// const StyledAppBar = styled(AppBar)({
//   top: 'auto',
//   bottom: 0,
//   backgroundColor: '#2D2076',
//   position: 'fixed',
// });

// const LogoIcon = styled(Box)({
//   width: '20px',
//   height: '20px',
//   backgroundColor: 'white',
//   borderRadius: '50%',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   marginRight: '6px',
// });

// const LogoIconInner = styled(Box)({
//   width: '8px',
//   height: '8px',
//   backgroundColor: '#2D2076',
//   borderRadius: '50%',
// });

// const SignIn: React.FC<SignInProps> = ({ onSubmit }) => {
//   const [username, setUsername] = useState<string>('');
//   const [password, setPassword] = useState<string>('');

//   const handleSubmit = () => {
//     if (onSubmit) {
//       onSubmit(username, password);
//     }
//   };

//   return (
//     <>
//       <Box sx={{ 
//         overflow: 'hidden',
//         minHeight: '100vh',
//         backgroundColor: '#f5f5f5'
//       }}>
//         <StyledContainer maxWidth={false} disableGutters>
//           <StyledBox>
//             <div className='header_sign'></div>
//             <StyledTitle variant="h1">
//               Signin
//             </StyledTitle>
            
//             <Stack spacing={4} alignItems="center">
//               <StyledTextField
//                 label="User Name"
//                 variant="outlined"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 fullWidth
//               />
              
//               <StyledTextField
//                 label="Password"
//                 type="password"
//                 variant="outlined"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 fullWidth
//               />
              
//               <StyledButton 
//                 variant="contained"
//                 onClick={handleSubmit}
//               >
//                 Enter
//               </StyledButton>
//             </Stack>
//           </StyledBox>
//         </StyledContainer>
//       </Box>

//       <StyledAppBar>
//         <Toolbar sx={{ justifyContent: 'center' }}>
//            <img src={Appgate_Logo} alt="Delete"  />
//         </Toolbar>
//       </StyledAppBar>
//     </>
//   );
// };

// export default SignIn;